export default __webpack_public_path__ + "static/media/apple-cal-feature-de.812f58a8.png";